var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 115,
    viewBox: "0 0 140 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 45V33.5C49 24.9396 55.9396 18 64.5 18C73.0604 18 80 24.9396 80 33.5V45H49ZM42 45L42 33.5C42 21.0736 52.0736 11 64.5 11C76.9264 11 87 21.0736 87 33.5V45H88C94.6274 45 100 50.3726 100 57V93C100 99.6274 94.6274 105 88 105H42C35.3726 105 30 99.6274 30 93V57C30 50.3726 35.3726 45 42 45ZM71.7281 70.4142L70.3139 69L65.3637 73.9502L60.4142 69.0008L59 70.415L63.9495 75.3644L59.0002 80.3137L60.4144 81.7279L65.3637 76.7786L70.3137 81.7287L71.7279 80.3145L66.7779 75.3644L71.7281 70.4142Z",
    fill: "#114BC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3db826113102fc9139169d96b5872593.svg";
export { ForwardRef as ReactComponent };